import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

import IconPattern from '@mlb/react-patterns/components/Icon/icon';
import COLORS from '@mlb/react-patterns/style/universal.color';

import { useDictionary } from 'bdvp-common/src/hooks/config';

import Wrapper from '../ModalViewWrapper';
import Message from './Message';

const spin = () => {

    return keyframes`
        100% {
            transform: rotate(360deg);
        }
    `;

};

const Icon = styled(IconPattern)`
    -webkit-animation:${spin} 2s linear infinite;
    -moz-animation:${spin} 2s linear infinite;
    animation:${spin} 2s linear infinite;
    margin-bottom: 20px;
`;

const Loading = (props) => {

    const { lastModalNode } = props;

    const {
        reel_loading_message: reelLoadingMessage = 'Your reel is processing...',
    } = useDictionary();

    return (
        <Wrapper>
            <Icon
                name={'baseball'}
                width={132}
                fill={COLORS.mlbGrey5}
            />
            <Message
                tabIndex={0}
                ref={lastModalNode}
            >
                {reelLoadingMessage}
            </Message>
        </Wrapper>
    );

};

export default Loading;

Loading.propTypes = {
    lastModalNode: PropTypes.node,
};

Loading.defaultProps = {
    lastModalNode: undefined,
};
